// extracted by mini-css-extract-plugin
module.exports = {"comment_box_wrapper":"comment_text_box_comment_box_wrapper__LRSBI"};